var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    role: "img",
    width: "21px",
    height: "25px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg-profile"
  }, "Your Account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "svg-profile"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav---Black",
    transform: "translate(-1148.000000, -10.000000)",
    fill: "#111111",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1148.353846, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HNY-web-Profile",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6461538,15.5076923 C11.3638229,15.5076923 7.89230769,12.0361771 7.89230769,7.75384615 C7.89230769,3.47151517 11.3638229,0 15.6461538,0 C19.9284848,0 23.4,3.47151517 23.4,7.75384615 C23.4,9.81029401 22.5830793,11.7825151 21.128951,13.2366433 C19.6748228,14.6907716 17.7026017,15.5076923 15.6461538,15.5076923 Z M15.6461538,1.66153846 C12.2814652,1.66153846 9.55384615,4.38915752 9.55384615,7.75384615 C9.55384615,11.1185348 12.2814652,13.8461538 15.6461538,13.8461538 C19.0108425,13.8461538 21.7384615,11.1185348 21.7384615,7.75384615 C21.7384615,6.13806569 21.0965952,4.58846339 19.9540659,3.44593407 C18.8115366,2.30340475 17.2619343,1.66153846 15.6461538,1.66153846 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2923077,34.2775385 L0,34.2775385 L0,33.4467692 C0,24.8056371 7.00502168,17.8006154 15.6461538,17.8006154 C24.287286,17.8006154 31.2923077,24.8056371 31.2923077,33.4467692 L31.2923077,34.2775385 Z M1.68646154,32.616 L29.6058462,32.616 C29.1642843,25.2298193 23.0455216,19.4659253 15.6461538,19.4659253 C8.24678612,19.4659253 2.12802344,25.2298193 1.68646154,32.616 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2);
export default __webpack_public_path__ + "static/media/person-2.c63d5fe478428c5e4e0394939fdd81db.svg";
export { ForwardRef as ReactComponent };